export default "/images/heart-search-hint.png?8cdcce2501750664f9619f505cfbf195";